const getters = {
  // app;
  sidebar: state => state.app.sidebar,
  size: state => state.app.size,
  device: state => state.app.device,
  //sim数量详情
  count:         state => state.simControl.count,
  activedCount:  state => state.simControl.activedCount,
  useingCount:   state => state.simControl.useingCount,
  noActiveCount: state => state.simControl.noActiveCount,
  testedCount:   state => state.simControl.testedCount,
  stopedCount:   state => state.simControl.stopedCount,
  logOffCount:   state => state.simControl.logOffCount,
  unKnowCount:   state => state.simControl.unKnowCount,
  expireCount:   state => state.simControl.expireCount,
  unExpireCount: state => state.simControl.unExpireCount,
  //user
  username: state => state.user.username,
  customid: state => state.user.customid,
  permission_routes: state => state.permission.routes,
  auth_list: state => state.permission.addRoutes,
  rawAuth : state => state.user.rawAuth, 
  token: state => state.user.token,
  isLogin : state => state.user.isLogin,
  cpy_name : state => state.user.cpy_name,
  customlist: state => state.user.customList,
  billlist: state => state.user.setmealList,
  level: state => state.user.level,
  email: state => state.user.email,
  phone: state => state.user.phone,
  remark: state => state.user.remark

}
export default getters



// WEBPACK FOOTER //
// ./src/store/getters.js